import { render } from "./VideoDiv.vue?vue&type=template&id=16692294&scoped=true&ts=true"
import script from "./VideoDiv.vue?vue&type=script&lang=ts"
export * from "./VideoDiv.vue?vue&type=script&lang=ts"

import "./VideoDiv.vue?vue&type=style&index=0&id=16692294&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16692294"]])

export default __exports__